import React from 'react';
import { AppBar, Toolbar, IconButton, Box, Avatar, useMediaQuery } from '@mui/material';
import { Menu, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useNavbarVisibility } from '../../context/NavbarVisibilityContext';

const TopNavBar = ({ onMenuClick, sidebarWidth }) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:900px)');
    const { hideNavbar } = useNavbarVisibility();

    if (hideNavbar) {
        return null;
    }

    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                width: { sm: `calc(100% - ${sidebarWidth}px)` },
                ml: { sm: `${sidebarWidth}px` },
                bgcolor: '#FFFFFF',
                color: '#222',
                borderBottom: '1px solid #E8E8E8',
                zIndex: 1201
            }}
        >
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {isMobile && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={onMenuClick}
                            sx={{ mr: 2 }}
                        >
                            <Menu size={24} />
                        </IconButton>
                    )}
                    {isMobile && (
                        <img
                            src="/Logo.webp"
                            alt="Logo" loading='lazy'
                            style={{ height: '30px', cursor: 'pointer' }}
                            onClick={() => navigate('/dashboard')}
                        />
                    )}
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
                        onClick={() => navigate('profile')}
                        sx={{
                            p: 0.5,
                            border: '1.5px solid #E8E8E8',
                        }}
                    >
                        <Avatar
                            sx={{
                                width: 32,
                                height: 32,
                                bgcolor: '#222',
                                color: '#FFF'
                            }}
                        >
                            <User size={20} />
                        </Avatar>
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopNavBar;
